// Firefox 1.0+
export const isFirefox = navigator.userAgent.indexOf('Firefox') > -1;
